<div class="list-modal__content">
  <ion-row class="list-modal__header ion-align-items-center ion-justify-content-between">
    <ion-col size="auto" class="list-modal__label">{{ label | translate }}</ion-col>
    <ion-col size="auto"><i class="list-modal__close-btn" (click)="closeModal()"></i></ion-col>
  </ion-row>
  <div class="list-modal__list-container">
    <div *ngFor="let value of values; let itemIndex = index" class="list-modal__list-item">
      <span>{{ itemIndex + 1 }}. {{ value.displayName.toString() | translate }}</span>
      <img *ngIf="value.icon" [src]="value.icon" class="list-modal__list-icon" />
    </div>
  </div>
</div>
